<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span>Chương trình</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        
          <b-row>
            <b-col md="12">
             Cập nhật thành công!
            </b-col>
          </b-row>
       </div>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
    
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    

    async fn_initDataDefault() {},

    fn_hashUrl() {
// debugger;
    let pathLocation =
        location.protocol + "//" + location.host + "/admin/DangKyChuongTrinh";
    window.top.location.href=pathLocation;
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
